// extracted by mini-css-extract-plugin
export default {"statusAccepted":"GuestCard_statusAccepted__G+PIa","statusDeclined":"GuestCard_statusDeclined__6Q83g","messages":"GuestCard_messages__pfjAQ","message":"GuestCard_message__As9YY"};